import React from 'react'

const JobRemoved = () => {
  return (
    <div>JobRemoved</div>
  )
}

export default JobRemoved